import pick from 'lodash/pick';
import { isEmpty } from 'lodash';
import groupBy from 'lodash/groupBy';
import { types } from './types';
// import { isNil } from 'lodash';
import {
  documentKeys,
  carrierKeys,
  termsKeys,
  AssetKeys,
  auditorKeys,
  objectionCommitteeKeys,
  supplierKeys,
} from 'store/utils';
import { calculateBusinessPlanOverviewTables } from './utils';
import { sorefsisError } from './actions';

const INITIAL_STATE = {
  documents: {},
  carrier: {
    viewMode: false,
    existCon: true,
    contactPersonFlag: true,
    additionalServices: true,
    ownerStatus: 'ownerStatusOwner',
    residence: true,
    powerSupply: true,
    powerSupplyPrivate: true,
    powerSupplyPublic: true,
    ameaMember: false,
    rejectReasons: {
      isSubmitValid: true,
    },
    currentSubTab: 0,
    abiDistrictBuildingOptions:[],
    buildPerfectureBuildingOptions:[],
    abiDistrictOptions:[],
    abiPerfectureOptions:[],
  },
  formId: '',
  task: {},
  content: [],
  localeStrings: [],
  loadingLocales: false,
  appConfig: {
    initiated: false,
    hasError: false,
    hasInfo: false,
    loading: false,
    message: '',
    gsisAuthUrl: true,
    rememberMe: false,
  },
  applicationLoading: false,
  disableInLoading: false,
  audit: {
    ameaMemberAud: false,
    powerSupplyAud: false,
    powerSupplyPrivateAud: false,
    powerSupplyPublicAud: false,
    legalChildrenAud: false,
    //vulnerableHouseholdAud: false,
    sorefsisAud: false,
    vulnerableHousehold: '',
    preApprovalAud: false,
    preRejectAud: false,
    preReturnAud: false,
    consent: false
  },
  objCommittee: {
    // ameaMemberObjCommittee: false,
    // powerSupplyObjCommittee: false,
    // powerSupplyPrivateObjCommittee: false,
    // powerSupplyPublicObjCommittee: false,
    // legalChildrenObjCommittee: false,
    // vulnerableHouseholdObjCommittee: false,
    // sorefsisObjCommittee: false,
    preApprovalObjCommittee: false,
    consentByCommittee: false,
    // vulnerableHousehold: '',
    // consent: false
  },
  individualIncomeValidation: {
    loading: false,
    data: null,
    error: null,
    validated: false
  },
    familyIncomeValidation: {
    loading: false,
    data: null,
    error: null,
    validated: false
  },
};

const reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.SET_FORM_INITIATED:
      return { ...state, initiated: true };

    case types.SET_FORM_INFO:
      return { ...state, hasInfo: true, message: payload };

    case types.UPDATE_USER.SUCCESS:
      return { ...state, ...payload };

    case types.UPLOAD_FILE.SUCCESS:
      return {
        ...state,
      };

      case types.LOAD_SYSTEM_LOCALES.START:
        return {
          ...state,
          loadingLocales: true, // Set loading to true when fetching locales
        };
  
      case types.LOAD_SYSTEM_LOCALES.SUCCESS: {
        const locales = {}; // Declare locales only once
        if (Array.isArray(payload)) {
          payload.forEach(({ name, localString }) => {
            locales[name] = localString;
          });
        } else {
          console.warn("LOAD_SYSTEM_LOCALES.SUCCESS payload is not an array:", payload);
        }
  
        return {
          ...state,
          localeStrings: locales,  // Store fetched locales
          loadingLocales: false,   // Set loading to false when locales are fetched
        };
      }
  
      case types.LOAD_SYSTEM_LOCALES.ERROR:
        return {
          ...state,
          loadingLocales: false,  // Set loading to false if fetching fails
        };

    case types.LOGIN_START:
      return { ...state, loading: true, hasError: false, message: '' };

    case types.LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        hasError: false,
        message: '',
      };

    case types.LOGIN_ERROR:
      return {
        ...state,
        loading: false,
        hasError: true,
        message: payload,
      };

    case types.RESET_USER:
      console.log('Reducer - Resetting User');
      return {
        ...state,
        initiated: false,
        hasError: false,
        hasInfo: false,
        loading: false,
        message: '',
        gsisAuthUrl: null,
        rememberMe: false,
      };

case types.UPDATE_FORM_FIELD_FORMS:  
  return {
    ...state,
    [payload.group]: {
      ...state[payload.group],
      [payload.key]: payload.value,
    },
  };
    case types.GET_PROCESS_INSTANCES.SUCCESS:
      const content = groupBy(payload.content, 'field');
      return {
        ...state,
        documents: {
          ...pick(payload.variables, documentKeys(payload.variables)),
          ...content,
        },
        carrier: {
          viewMode: state.carrier.viewMode,
          existCon: state.carrier.existCon,
          contactPersonFlag: state.carrier.contactPersonFlag,
          ...pick(payload.variables, carrierKeys(payload.variables)),
        },
        terms: {
          ...state.terms,
          ...pick(payload.variables, termsKeys(payload.variables)),
        },
        audit: {
          ...state.audit,
          ...pick(payload.variables, auditorKeys(payload.variables)),
        },
        objCommittee: {
          ...state.objCommittee,
          ...pick(payload.variables, objectionCommitteeKeys(payload.variables)),
        },
        supplier: {
          ...state.supplier,
          ...pick(!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed,
              supplierKeys(!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed)),
        },
        businessPlanDetails: {
          ...state.businessPlanDetails,
          ...pick(payload.variables, AssetKeys(payload)),
          ...pick(
            payload.variables,
            Object.keys(calculateBusinessPlanOverviewTables())
          ),
          ...pick(
            payload.variables,
            Object.keys(calculateBusinessPlanOverviewTables())
          ),
        },
        activeTaskName: payload?.activeTaskName || state.forms?.activeTaskName,
        businessKey: payload.businessKey || state.forms?.businessKey,
        task: {
          ...state.task,
          processInstanceId:
            payload?.processInstanceId || state.forms.task.processInstanceId,
          taskName: payload?.taskName || state.forms.task.taskName,
          taskKey: payload?.taskKey || state.forms.task.taskKey,
        },
      };
    case types.GET_FORM_DATA.SUCCESS :
      // const contentItems = groupBy(payload.contentItems, 'field');
      return {
        ...state,
        documents: {
          ...state.documents,
          ...pick(payload.variables, documentKeys(payload.variables)),
          // ...contentItems,
        },
        carrier: {
          ...state.carrier,

          viewMode: state.carrier.viewMode,
          ...pick(payload.variables, carrierKeys(payload.variables)),
        },
        terms: {
          ...state.terms,
          ...pick(payload.variables, termsKeys(payload.variables)),
        },
        audit: {
          ...state.audit,
          ...pick(payload.variables, auditorKeys(payload.variables)),
        },
        objCommittee: {
          ...state.objCommittee,
          ...pick(payload.variables, objectionCommitteeKeys(payload.variables)),
        },
        // supplier: {
        //   ...state.supplier,
        //   ...pick(!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed,
        //       supplierKeys(!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed)),
        // },
        businessPlanDetails: {
          ...state.businessPlanDetails,
          ...pick(payload.variables, AssetKeys(payload.variables)),
          ...pick(
            payload.variables,
            Object.keys(calculateBusinessPlanOverviewTables())
          ),
          ...pick(
            payload.variables,
            Object.keys(calculateBusinessPlanOverviewTables())
          ),
        },
        formId: payload?.taskKey || state.forms.formId,
        task: {
          ...state.task,
          processInstanceId:
            payload?.processInstanceId || state.forms.task.processInstanceId,
          taskName: payload?.taskName || state.forms.task.taskName,
          taskKey: payload?.taskKey || state.forms.task.taskKey,
        },
        activeTaskName: payload?.taskName,
      };
      case types.GET_MAINFORM_DETAILS.SUCCESS :
        return {
          ...state,
          documents: {
            ...state.documents,
            ...pick(!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed,
               documentKeys(!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed)
            ),
            contentItems: payload.contentItems ?? [],
          },
          carrier: {
            ...state.carrier,
            viewMode: state.carrier.viewMode,
            ...pick(!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed,
               carrierKeys(!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed)),
          },
          terms: {
            ...state.terms,
            ...pick(!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed,
            termsKeys(!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed)),
          },
          audit: {
            ...state.audit,
            ...pick(!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed,
              auditorKeys(!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed)),
          },
          objCommittee: {
          ...state.objCommittee,
          ...pick(!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed,
              objectionCommitteeKeys(!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed)),
          },
          supplier: {
          ...state.supplier,
          ...pick(!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed,
              supplierKeys(!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed)),
          },
          formId: payload?.taskKey || state.forms?.formId,
          submissionDate: !isEmpty(payload.localTaskVariables.submissionDate) ? payload.localTaskVariables.submissionDate : payload.variablesIndexed.submissionDate,
          task: {
            ...state.task,
            // processInstanceId:
            //   payload?.processInstanceId || state.forms?.task?.processInstanceId,
            // taskName: payload?.taskName || state.forms?.task?.taskName,
            // taskKey: payload?.taskKey || state.forms?.task?.taskKey,
          },
          activeTaskName: payload?.activeTaskName,
          businessKey: payload?.businessKey,

        };
    case types.GET_TASK_DATA.SUCCESS:
      return {
        ...state,
        task: {
          ...state.task,
          ...payload,
        },
      };
      case types.GET_TAXIS_DATA_BY_TK.SUCCESS:
        return {
          ...state,
          carrier: {
            ...state.carrier,
            abiDistrictBuildingOptions: [
              ...Array.from(
                new Set(payload.map(b=>b.area))
              ).map(area=>({
                value: area,
              })),
              { value: "Άλλο" }
            ],
            buildPerfectureBuildingOptions: Array.from(
              new Set(payload.map(b=>b.nomos))
            ).map(nomos=>({
              value: nomos,
            }))
          },
        };
        case types.GET_TAXIS_DATA_BY_ABI_TK.SUCCESS:
          return {
            ...state,
            carrier: {
              ...state.carrier,
              abiDistrictOptions: [
                ...Array.from(
                  new Set(payload.map(b=>b.area))
                ).map(area=>({
                  value: area,
                })),
                { value: "Άλλο" }
              ],
              abiPerfectureOptions: Array.from(
                new Set(payload.map(b=>b.nomos))
              ).map(nomos=>({
                value: nomos,
              })),
            },
          };
      
    case types.GET_OTP.SUCCESS:
      return {
        ...state,
        // task: {
        //   ...state.task,
        //   ...payload,
        // },
      };
    case types.UPDATE_BUSINESS_PLAN_EXPENSE:
      return {
        ...state,
        businessPlanDetails: {
          ...state.businessPlanDetails,
          ...calculateBusinessPlanOverviewTables(state),
        },
      };
    case types.START_NEW.SUCCESS:
      return {
        ...state,
        taskId: payload.taskId || state.forms.taskId,
        task: {
          ...state.task,
          processInstanceId: payload.processInstanceId,
        },
        carrier: {
          ...state.carrier,
          viewMode: false,
        },
      };
    case types.CLAIM_ACTIVE.SUCCESS:
      return {
        ...state,
        taskId: payload.taskId || state.forms.taskId,
      };
    case types.CLAIM_ACTIVE_VIEW_MODE.SUCCESS:
      return {
        ...state,
        taskId: payload.taskId || state.forms.taskId,
      };
    case types.GET_FORM_UPLOADS.SUCCESS:
      return {
        ...state,
        content: payload.data,
      };
      case types.SUBMIT_CONSENT.SUCCESS:
      return {
        ...state,
        audit: {
          ...state.audit,
          consent: payload.consent,
        },
      };
    case types.GET_PROJECT_PLAN_INFO.SUCCESS:
      return {
        ...state,
        projectPlanInfo: payload,
      };
    case types.SOREFSIS_ERROR:
      return {
        ...state,
        sorefsisError: payload,
      };
    case types.CLEAR_FORM.SUCCESS:
      return INITIAL_STATE;

    case types.VALIDATE_OTP.SUCCESS:
      return {
        ...state,
        carrier: {
          ...state.carrier,
          [payload.field + 'Validated']: true,
          otpError: payload.otpError,
        },
      };
    case types.VALIDATE_OTP.ERROR:
      return {
        ...state,
        carrier: {
          ...state.carrier,
          [payload.field + 'Validated']: false,
          otpError: payload.otpError,
        },
      };
    case types.APPROVE_AUDIT.START:
      return {
        ...state,
        submitting: true,
      };
    case types.APPROVE_AUDIT.ERROR:
      return {
        ...state,
        submitting: false,
      };
    case types.REJECT_AUDIT.START:
      return {
        ...state,
        submitting: true,
      };
    case types.REJECT_AUDIT.ERROR:
      return {
        ...state,
        submitting: false,
      };
    case types.APPROVE_OBJECTION.START:
      return {
        ...state,
        submitting: true,
      };
    case types.APPROVE_OBJECTION.ERROR:
      return {
        ...state,
        submitting: false,
      };
    case types.REJECT_OBJECTION.START:
      return {
        ...state,
        submitting: true,
      };
    case types.REJECT_OBJECTION.ERROR:
      return {
        ...state,
        submitting: false,
      };
    case types.REJECT_TASK.START:
      return {
        ...state,
        submitting: true,
      };
    case types.REJECT_TASK.ERROR:
      return {
        ...state,
        submitting: false,
      };
    case types.SUBMIT_TASK.START:
      return {
        ...state,
        submitting: true,
      };
    case types.SUBMIT_TASK.SUCCESS:
      return {
        ...state,
        submitting: false,
      };
    case types.SUBMIT_TASK.ERROR:
      return {
        ...state,
        submitting: false,
      };
    case types.UPDATE_FORM_VALIDITY:
      return {
        ...state,
        formValidity: {
          ...state.formValidity,
          [payload.group]: payload.value,
        },
      };
    // case types.SUBMIT_CONSENT.SUCCESS:
    //   return {
    //     ...state,
    //     consent: payload.consent,
    //   };
    case types.TRIGGER_LOADING:
      return {
        ...state,
        applicationLoading: payload,
      };
      
    case types.DISABLE_IN_LOADING:
      return {
        ...state,
        disableInLoading: payload,
      };
      case types.INDIVIDUAL_INCOME_VALIDATION.START:
  return {
    ...state,
    individualIncomeValidation: {
      ...state.individualIncomeValidation,
      loading: true,
      error: null
    }
  };

case types.INDIVIDUAL_INCOME_VALIDATION.SUCCESS:
  return {
    ...state,
    individualIncomeValidation: {
      loading: false,
      data: payload,
      error: null,
      validated: true
    }
  };

case types.INDIVIDUAL_INCOME_VALIDATION.ERROR:
  return {
    ...state,
    individualIncomeValidation: {
      loading: false,
      data: null,
      error: payload,
      validated: false
    }
  };
  case types.FAMILY_INCOME_VALIDATION.START:
  return {
    ...state,
    familyIncomeValidation: {
      ...state.familyIncomeValidation,
      loading: true,
      error: null
    }
  };

case types.FAMILY_INCOME_VALIDATION.SUCCESS:
  return {
    ...state,
    familyIncomeValidation: {
      loading: false,
      data: payload,
      error: null,
      validated: true
    }
  };

case types.FAMILY_INCOME_VALIDATION.ERROR:
  return {
    ...state,
    familyIncomeValidation: {
      loading: false,
      data: null,
      error: payload,
      validated: false
    }
  };
  case types.SUPPLIER_UPDATE_EQUIPMENT.SUCCESS:
    return {
      ...state,
      supplier: {
        ...state.supplier,
        voucherInfo: payload,
        error: null,
      }
    };
  case types.SUPPLIER_UPDATE_EQUIPMENT.ERROR:
    return {
      ...state,
      supplier: {
        ...state.supplier,
        error: payload
      }
    };
  case types.GET_VOUCHER.SUCCESS:
  return {
    ...state,
    supplier: {
      ...state.supplier,
      voucherInfo: payload,
    }
  };
  case types.GET_VOUCHER.ERROR:
  return {
    ...state,
    supplier: {
      voucherInfo: payload,
    }
  };
  case types.GET_VOUCHER_AUDITOR.SUCCESS:
  return {
    ...state,
    supplier: {
      ...state.supplier,
      voucherInfo: payload,
    }
  };
  case types.GET_VOUCHER_AUDITOR.ERROR:
  return {
    ...state,
    supplier: {
      voucherInfo: payload,
    }
  };
  case types.VOUCHER_AUDITOR_SET_AUDIT_STATUS.ERROR:
  return {
    ...state,
    supplier: {
        ...state.supplier,
        error: payload
      }
  };
  case types.SEND_OTP_VOUCHER.SUCCESS:
      return {
        ...state,
        otpVoucher: payload,
      };
  case types.SEND_OTP_VOUCHER.ERROR:
      return {
        ...state,
        otpVoucher: payload,
      };
  default:
      return state;
  }
};


export default reducer;
